import { MatDialogRef } from '@angular/material/dialog';
import { Sc3FailedMessagesListSearchCriteria } from '../../models';
import { ExportDialogComponent } from '../../../../../../ui-kit';

export class Sc3FailedMessagesExportStart {
  public static readonly type = '[Sc3FailedMessagesExport] Start';

  constructor(
    public payload: {
      searchCriteria: Sc3FailedMessagesListSearchCriteria;
      reportName: string;
      dialogRef: MatDialogRef<ExportDialogComponent>;
      navigationNeeded: boolean;
    },
  ) {}
}

export class Sc3FailedMessagesExportSetInitialState {
  public static readonly type = '[Sc3FailedMessagesExport] Set Initial State';
}
